module.exports = __webpack_public_path__ + "152ada9f604a192a7560c3fee4b4d02b.jpg";